export default {
  env: 'dev',
  host: 'http://www.localbeta.com',
  authHost: 'https://onboarding.panasiapayment.com/',
  appkey: '99a81abe42ca42b870f37ac8febcdbf9',
  secret: '474299362bcf43955550a937ef62ec2f',
  notifyHost: 'post-cn-st21t9aw80e.mqtt.aliyuncs.com',
  microBiz: '//localhost:8001',
};
